import axios, { AxiosResponse } from 'axios';

import { IOsobyGetResp } from './zadostPravo';

export interface IZadostiInput {
    offset: number;
    order: string;
    limit: number;
}

export interface IZadostiTable {
    offset: number;
    limit: number;
    count: number;
    order: string;
    zadost?: IZadosti;
    lastid?: number;
    zadosti?: IZadosti[];
}

export enum EStavZadostAmlz {
    ROZP = 'ROZP', // rozpracováno
    KONTR = 'KONTR', // Kontroluje
    KDOPL = 'KDOPL', // k doplnění
    HOTOVO = 'HOTOVO', // hotovo
    NOVA = 'NOVA', // hotovo
    DOPL = 'DOPL', // rozpracovaná
    UZIVCEKA = 'UZIVCEKA', // čeka na identifikaci uživatele
    UZIVDOPL = 'UZIVDOPL', // uživatatel doplnil údaje
    CDCPKEKONTR = 'CDCPKEKONTR', //  čeká na schválení
    AUTKONTROLA = 'AUTKONTROLA',
    CDCPKONTR = 'CDCPKONTR', // CDCP Kontroluje žádost
    CDCPKDOPL = 'CDCPKDOPL', // CDCP vrací žádost k doplnění
    INI = 'INI', // prvotní nastavení osoby co již existuje
    UZIVEMAIL = 'UZIVEMAIL', // znovu poslat e-mail
    HOTOVOIIS = 'HOTOVOIIS',
    ODEBRAT = 'ODEBRAT',
    PRIDAT = 'PRIDAT',
    ZAMITNUTO = 'ZAMITNUTO',
    ZNEPLATNENO = 'ZNEPLATNENO'
}

export interface IZadosti {
    idzadosti: number;
    datum: string;
    puvtyp: true;
    stav: EStavZadostAmlz;
    typ: string;
}

export const historickeZadostiOsobyC2 = (data: IZadostiInput) => {
    return axios({
        method: 'GET',
        url: '/AMLosobyc2/historie',
        params: data
    }).then((resp: AxiosResponse<IOsobyGetResp>) => resp.data);
};

const historickeZadostiApi = (data: IZadostiInput) => {
    return axios({
        method: 'GET',
        url: '/AML/historie',
        params: data
    }).then((resp: AxiosResponse<IZadostiTable>) => resp.data);
};

export default historickeZadostiApi;
